export function removeSeconds(time: null | string | undefined): string {
  if (!time) {
    return ''
  }

  const parts = time.split(':')
  if (parts.length < 2) {
    return time
  }

  return `${parts[0]}:${parts[1]}`
}
